import ListPage, { useList } from '@/components/BaseList';
import { usePermission } from '@/common/hooks/index';
import { httpPageOdsGdIcd10Code } from '@/services/datamanagement';
import React from 'react';
import SearchForm from './components/SearchForm';
import styles from './index.less';

/**
 * 疾病分类与代码（2019）
 * @returns
 */
const DiseaseClassifyCode: React.FC = () => {
  const { permission } = usePermission();

  const list = useList();
  const fetchAPi = (params: any) => {
    const req: any = {
      // ...params,
      limit: params.pageSize,
      pageNo: params.current,
      cond: {
        ficdm: params.ficdm,
        fjbname: params.fjbname,
      },
      // orders: [
      //   {
      //     direction: params.direction === 'ascend' ? 'ASC' : 'DESC',
      //     property: params.property || 'createTime',
      //   },
      // ],
    };

    return httpPageOdsGdIcd10Code(req).then((res) => {
      return {
        listData: res.data,
        pagination: {
          current: res.pageIndex,
          pageSize: res.pageSize,
          total: res.totalCount,
        },
      };
    });
  };

  const changetable = (pagination: any, filters: any, sorter: any) => {
    const property: string = sorter.columnKey;
    list.current.fetchListData({ direction: sorter.order, property });
  };

  const columns = [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      width: 100,
      children: [
        {
          title: 'id',
          dataIndex: 'id',
          key: 'id',
          width: 100,
        },
      ],
    },
    {
      title: '疾病编码',
      dataIndex: 'ficdm',
      key: 'ficdm',
      width: 160,
      children: [
        {
          title: 'ficdm',
          dataIndex: 'ficdm',
          key: 'ficdm',
          width: 160,
        },
      ],
      render(text: string, record: any) {
        return <div className={`${styles.tag}`}>{text}</div>;
      },
    },
    {
      title: '疾病名称',
      dataIndex: 'fjbname',
      key: 'fjbname',
      minWidth: 300,
      children: [
        {
          title: 'fjbname',
          dataIndex: 'fjbname',
          key: 'fjbname',
          width: 300,
        },
      ],
      render(text: string, record: any) {
        return <div className={`${styles.tag}`}>{text}</div>;
      },
    },
    {
      title: '首字母简称',
      dataIndex: 'fzjc',
      key: 'fzjc',
      children: [
        {
          title: 'fzjc',
          dataIndex: 'fzjc',
          key: 'fzjc',
        },
      ],
    },
    {
      title: '编码版本',
      dataIndex: 'ficdversion',
      key: 'ficdversion',
      width: 200,
      children: [
        {
          title: 'ficdversion',
          dataIndex: 'ficdversion',
          key: 'ficdversion',
          width: 200,
        },
      ],
    },
  ];

  return (
    <div className={styles.disease}>
      <ListPage
        list={list}
        fetchApi={fetchAPi}
        columns={columns}
        SearchForm={permission.sysSearchBtn && SearchForm}
        BodyProps={{
          onChange: (pagination: any, filters: any, sorter: any) => {
            changetable(pagination, filters, sorter);
          },
        }}
      />
    </div>
  );
};

export default DiseaseClassifyCode;
